import imagesLoaded from "imagesloaded";
import $ from "jquery";
import jQueryBridget from "jquery-bridget";
import Masonry from "masonry-layout";

function init() {
  jQueryBridget("masonry", Masonry, $);
  jQueryBridget("imagesLoaded", imagesLoaded, $);

  const $container = $(".js-masonry-layout");
  const $containerOrdered = $container.find(".masonry-layout--ordered");
  const $containerOriginLeft = $container.hasClass("js-masonry-left");

  const masonryOptions = {
    columnWidth: ".js-masonry-layout-sizer",
    itemSelector: ".js-masonry-layout-item",
    originLeft: $containerOriginLeft,
    percentPosition: true
  };

  $container.imagesLoaded(() => {
    if ($containerOrdered.length) {
      let viewportWidth;

      const setViewportWidth = () => {
        viewportWidth =
          window.innerWidth || document.documentElement.clientWidth;
      };

      const logWidth = () => {
        if (viewportWidth < 720) {
          $container.append($containerOrdered);
        } else {
          $container.prepend($containerOrdered);
        }
      };

      setViewportWidth();
      logWidth();
      $container
        .masonry({
          ...masonryOptions
        })
        .masonry("reloadItems");

      window.addEventListener(
        "resize",
        () => {
          setViewportWidth();
          logWidth();
          $container.masonry("reloadItems");
        },
        false
      );
    } else {
      $container.masonry({
        ...masonryOptions
      });
    }
  });
}

export default { init };
